import React from "react";
import Layout from "../../components/layouts/layout";
import BannerBgImage from "../../assets/Images/services/consult-banner.png";
import TwoColumnContactInfo from "../../templates/TwoColumnContactInfo";
import Clm1Img from "../../assets/Icons/phone.svg";
import Clm2Img from "../../assets/Icons/mail.svg";
import BannerSection from "../../components/servicesSection/banner";
import OurOffering from "../../components/servicesSection/ourOffering";
import CtaCardSection from "../../components/CTASection/ctaCard2";
import CTAIMAGE1 from "../../assets/Images/Clutch/Cta/phone-contact.png";
import FullStackExpertise from "../../components/FullStackExpertise";
import Box from "../../templates/Box";
import ConsultImage from "../../assets/Images/Homepage/FullStackExpertise/consult.png";
import ProductStrategy from "../../assets/Images/services/consult/Product-Strategy.png";
import CXStrategy from "../../assets/Images/services/consult/CX-Strategy.png";
import AI_MLStrategy from "../../assets/Images/services/consult/AI_MLStrategy.png";
import AppModern from "../../assets/Images/services/consult/AppModern.png";
import AWS_Solutions from "../../assets/Images/services/consult/AWS_Solutions.png";
import AIDrivenSDLC from "../../assets/Images/services/consult/AIDrivenSDLC.png";
import DataArchitecture from "../../assets/Images/services/consult/DataArchitecture.png";
import Transformation from "../../assets/Images/services/consult/Transformation.png";
import DisasterRecovery from "../../assets/Images/services/consult/DisasterRecovery.png";
import ProductScaling from "../../assets/Images/services/consult/ProductScaling.png";
import AgileTrans from "../../assets/Images/services/consult/AgileTrans.png";
import IT_Risk_Assurance from "../../assets/Images/services/consult/IT_Risk_Assurance.png";
import OurModelSection from "../../components/OurModelSection";

function ConsultScreen() {
  const offerList = [
    {
      label: "Product Strategy",
      details:
        "Define your product vision and prioritise features for market fit, leveraging competitive analysis and user insights to maximise ROI and accelerate time-to-market.",
      buttonName: "Ask About Our Product Strategy",
      image: ProductStrategy,
    },
    {
      label: "CX Strategy",
      details:
        "Articulate your unique customer value proposition and journey, identifying growth opportunities through targeted experience enhancements and seamless omnichannel interactions.",
      buttonName: "Ask About Our CX Strategy",
      image: CXStrategy,
    },
    {
      label: "AI & ML Strategy",
      details:
        "Align your business goals with scalable AI/ML roadmaps, leveraging data-driven insights, model governance, and Gen AI integration to drive innovation and competitive advantage.",
      buttonName: "Ask About Our AI & ML Strategy",
      image: AI_MLStrategy,
      path: "/machine-learning",
    },
    {
      label: "Application Modernisation",
      details:
        "Transform legacy systems to cloud-native, API-first microservices, migrating monoliths to headless platforms with Gen AI for scalability.",
      buttonName: "Ask About Our Application Modernisation.",
      image: AppModern,
    },
    {
      label: "AWS Solutions",
      details:
        "Optimise AWS with secure, serverless architectures, automated IaC, cloud-native services, and resilient scaling strategies. Ensure efficiency, reliability, and cost control at every stage.",
      buttonName: "Ask About Our AWS Solutions",
      image: AWS_Solutions,
    },
    {
      label: "AI-Driven SDLC",
      details:
        "Embed AI-powered automation into your development lifecycle, enhancing code quality, predictive testing, and continuous delivery pipelines to accelerate releases.",
      buttonName: "Ask About Our AI-Driven SDLC",
      image: AIDrivenSDLC,
    },
    {
      label: "Data Architecture",
      details:
        "Craft a robust, scalable data foundation with governed pipelines, data modelling for scalability, modern data lakes, and real-time analytics to deliver reliable insights and drive data-driven decisions.",
      buttonName: "Ask About Our Data Architecture",
      image: DataArchitecture,
    },
    {
      label: "Disaster Recovery & Business Continuity Planning",
      details:
        "Develop comprehensive disaster recovery strategies and failover processes, ensuring your critical systems and data remain resilient, available, and compliant under any disruption.",
      buttonName: "Ask About Our Disaster Recovery",
      image: DisasterRecovery,
    },
    {
      label: "Digital Transformation",
      details:
        "Guide your organisation through digital reinvention, integrating emerging technologies, process automation, and cultural change to unlock efficiency and sustainable advantage.",
      buttonName: "Ask About Our Digital Transformation",
      image: Transformation,
      path: "/digital-transformation",
    },
    {
      label: "Product Scaling",
      details:
        "Accelerate your product’s growth with scalable architecture, automated operations, and performance tuning to ensure seamless user experiences under increasing demand.",
      buttonName: "Ask About Our Product Scaling",
      image: ProductScaling,
      path: "/product-scaling",
    },
    {
      label: "Agile Transformation",
      details:
        "Empower your teams with agile frameworks, lean governance, and continuous improvement practices to enhance collaboration, accelerate delivery, and adapt to change.",
      buttonName: "Ask About Our Agile Transformation.",
      image: AgileTrans,
    },
    {
      label: "IT Risk & Assurance",
      details:
        "Assess and strengthen your IT controls, policies, and compliance posture, mitigating risks and ensuring security, governance, and regulatory adherence across your landscape.",
      buttonName: "Ask About Our IT Risk & Assurance",
      image: IT_Risk_Assurance,
    },
  ];
  const TwoColumnContactInfoData = {
    Clm1Img: Clm1Img,
    Clm1Title: "Phone:",
    Clm1SubTitle: "+44 (0) 161 706 7983",
    Clm2Img: Clm2Img,
    Clm2Title: "Email:",
    Clm2SubTitle: "hello@digiryte.com",
  };
  const BoxData = {
    boxBtn1Width: "230px",
    boxBtn1Height: "46px",
    boxBtn1variant: "contained",
    boxBtn1color: "primary",
    boxBtn1label: "Career",
    tip: "Career",
    tooltip: "no",
    Clm2SubTitle: "careers@digiryte.com",
    boxBtn1Title: "Join our team",
    boxBtn1SubTitle: (
      <>
        If you're a designer or a developer <br /> who loves to challenge
        conventions,
        <br /> make the ryte move!
      </>
    ),
    boxBtn2Width: "230px",
    boxBtn2Height: "46px",
    boxBtn2variant: "contained",
    boxBtn2color: "primary",
    boxBtn2label: "Call us right now",
    boxBtn2Title: "Let’s talk",
    tip1: "Call us right now",
    boxBtn2SubTitle: (
      <>
        Have you got an exciting project that <br /> you'd like to discuss?{" "}
      </>
    ),
    route1: "/contact-us",
    route2: "/contact-us",
  };

  return (
    <Layout
      seo={{
        title: "Service - Consult | Digiryte",
        ogtitle: "Service - Consult | Digiryte",
        description: "Consult",
      }}
    >
      <BannerSection
        bannerImage={BannerBgImage}
        title="Consult"
        subtitle={<>Strategic Digital Planning</>}
        image={ConsultImage}
      />

      <div className="mt-40">
        <div className="body-container">
          <OurOffering CardListData={offerList} pageName="consult" />
        </div>
      </div>
      <div className="mt-70 common-o-bg">
        <CtaCardSection
          className=""
          title={
            <>
              <span className="animationTitle">Ready to </span>
              partner with us?
            </>
          }
          imageUrl={CTAIMAGE1}
          imgClassName="custom-cta-img custom-cta-darken"
        />
      </div>
      <div className="mt-50">
        <FullStackExpertise
          parentWarp="services-modal-wrap"
          title="Other Services"
          showButton={false}
          showItems={["Audit", "Build"]}
          isServiceCard
        />
      </div>

      <div className="mt-30">
        <OurModelSection />
      </div>
      <div className="mt-70">
        {/* <Box BoxData={BoxData} /> */}

        <TwoColumnContactInfo
          TwoColumnContactInfoData={TwoColumnContactInfoData}
        />
      </div>
    </Layout>
  );
}

export default ConsultScreen;
